<template>
  <div class="row transaction">
    <div class="col-12 p-0 d-flex align-items-center justify-content-between">
      <div class="form-row p-0 align-items-center">
        <div class="col-auto">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="institutionName">Institution Name</option>
            <option value="institutionType">Institution Type</option>
            <option value="walletId">Wallet ID</option>
            <option value="phoneNumber">Phone Number</option>
            <option value="disabled">Status</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'institutionType'">
          <select
            class="form-control mb-2"
            v-model="searchValues[selectedValue]"
            placeholder="Select a search parameter"
          >
            <option value="">Select a institution type</option>
            <option value="bank">Bank</option>
            <option value="super-agent">Super Agent</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'disabled'">
          <select
            class="form-control mb-2"
            v-model="searchValues[selectedValue]"
            placeholder="Select a search parameter"
          >
            <option value="">Select a status</option>
            <option value="false">Enabled</option>
            <option value="true">Disabled</option>
          </select>
        </div>

        <div
          class="col-auto mt-4"
          v-if="
            selectedValue &&
            selectedValue !== 'disabled' &&
            selectedValue !== 'institutionType'
          "
        >
          <div class="input-group mb-2">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto">
          <button
            type="submit"
            class="btn btn-info mb-2 mt-4"
            @click="refresh('filter')"
          >
            Search
          </button>
        </div>
        <div class="col-auto">
          <button
            type="submit"
            class="btn btn-info mb-2 mt-4"
            @click="refresh('reload')"
          >
            Refresh
          </button>
        </div>
        <div class="col-auto">
          <button class="btn btn-info mb-2 mt-4" @click="refresh('download')">
            Download
          </button>
        </div>
      </div>

      <router-link class="btn btn-info" :to="`/dashboard/create-institution`">
        Add Institution</router-link
      >
    </div>

    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>
    <!-- <div class="p-4 col-12">
      <button class="btn btn-info m-2" @click="refresh('refresh')">
        Refresh
      </button>
    </div> -->

    <div class="col-12 p-0">
      <div
        class="card-plain"
        style="
          align-items: center;
          justify-content: center;
          display: flex;
          padding: 15px 0;
        "
      >
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Institution</th>
                <th scope="col" class="text-center">Institution Type</th>
                <th scope="col" class="text-center">Company Name</th>
                <th scope="col" class="text-center">RC Number</th>
                <th scope="col" class="text-center">Wallet Id</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">Address</th>
                <th scope="col" class="text-center">Status</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(institution, index) in institutions"
                :key="institution._id"
              >
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ institution.institutionName }}</td>
                <td class="text-center" style="text-transform: capitalize">
                  {{ institution.institutionType }}
                </td>
                <td class="text-center">{{ institution.companyName }}</td>
                <td class="text-center">{{ institution.regNumber }}</td>
                <td class="text-center">{{ institution.walletId }}</td>
                <td class="text-center">{{ institution.email }}</td>

                <!-- <td class="text-center">
                  {{ institution.walletBalance !== null && institution.walletBalance !== undefined ? `₦${format.format(institution.walletBalance.toFixed(4))}` : 'N/A' }}
                </td> -->
                <td class="text-center">{{ institution.phoneNumber }}</td>
                <td class="text-center">{{ institution.address }}</td>
                <td class="text-center text-uppercase">
                  <span
                    class="status"
                    :class="
                      institution.disabled
                        ? 'status-disabled'
                        : 'status-enabled'
                    "
                    >{{ institution.disabled ? "Disabled" : "enabled" }}</span
                  >
                </td>
                <td class="text-center">
                  <!-- <drop-down class="nav-item" title="Options" id="list">
                    <div class="p-2">                         -->
                  <router-link
                    :to="`/dashboard/institution/${institution._id}`"
                  >
                    View Institution</router-link
                  >
                  <!-- </div>
                  </drop-down> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn btn-primary"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button
          class="btn btn-primary"
          :disabled="!hasNextPage"
          @click="refresh('next')"
        >
          Next
        </button>
      </div>

      <div class="p-0">
        <div class="btn btn-primary">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      error: false,
      institutions: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      totalDocs: 0,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      currentPage: 1,
      selectedValue: "",
      searchValues: {
        institutionName: "",
        institutionType: "",
        email: "",
        walletId: "",
        phoneNumber: "",
        disabled: null,
      },
    };
  },

  methods: {
    async refresh(mode) {
      try {
        this.loading = true;
        this.errorMsg = "";
        this.error = false;
        let payload = {
          page: this.page,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { page: this.nextPage };
            break;
          case "previous":
            payload = { page: this.prevPage };
            break;
          case "reload":
            this.page = 1;
            payload = { page: this.page };
            this.selectedValue = "";
            this.searchValues = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
          payload,
        );
        const {
          docs,
          page,
          limit,
          totalDocs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
        } = res.data.institutions;
        this.institutions = docs;
        this.page = page;
        this.limit = limit;
        this.totalDocs = totalDocs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Institutions";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        institutionName: "",
        institutionType: "",
        email: "",
        walletId: "",
        phoneNumber: "",
        disabled: null,
      };
    },
  },

  watch: {
    // selectedValue() {
    //   this.clearSearchFields();
    //   this.refresh("reload");

    // },

    selectedValue(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        const tempValue = newValue;
        this.refresh("reload");
        this.selectedValue = tempValue;
      }
      this.clearSearchFields();
      this.previousValue = newValue;
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        page,
        limit,
        totalDocs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
      } = res.data.institutions;
      this.institutions = docs;
      this.page = page;
      this.limit = limit;
      this.totalDocs = totalDocs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Institutions";
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}

.pagination {
  justify-content: space-between;
  width: 100%;
}
</style>
